class KCVS.Views.LoadingView extends Backbone.View
  className: "loading-wheel"

  start: ->
    @$el.remove()
    $('.container-fluid').append(@render().el)
